module.exports = __webpack_public_path__ + "static/media/testimonial (1).2e3b3332.svg";